
// Definición de defaults

export const defaultParte: ParteProps = {
    id:                 0,
    idPersona:          0,
    persona:            '',
    idTipoParte:        0,
    tipoParte:          '',
    idTipoPersona:      0,
}

//Creación de interfaces

export interface ParteProps {
    id:                 number;
    idPersona:          number;
    persona:            string;
    idTipoParte:        number;
    tipoParte:          string;
    idTipoPersona:      number;
}
